import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules"; // додано імпорт модулю Autoplay
import "swiper/swiper-bundle.css"; // мінімізовані стилі для Swiper

interface CardSliderProps {
  settings: { [key: string]: any }; // Налаштування слайдера передаються як один обʼєкт
  children: React.ReactNode; // Дочірні елементи
  className?: string; // Додатковий клас для контейнера
}

const CardSlider: React.FC<CardSliderProps> = ({
  settings,
  children,
  className = "",
}) => {
  return (
    <div className={`swiper-container ${className}`}>
      <Swiper {...settings} modules={[Navigation, Pagination, Autoplay]}>
        {" "}
        {/* Додаємо Autoplay */}
        {React.Children.map(children, (child, index) => (
          <SwiperSlide key={index}>{child}</SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CardSlider;
